import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandSecondary, gray, green, white } from '../../styles/colors';
import { FontFamilies } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	wideDialog: {
		maxWidth: '800px',
		width: '90vw',
	},
	modalContent: {
		maxHeight: '60vh',
		overflowY: 'auto',
		padding: '20px 24px',
	},
	loadingState: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		minHeight: '200px',
	},
	loadingSpinner: {
		animation: 'spin 1s linear infinite',
		border: `3px solid ${gray}`,
		borderRadius: '50%',
		borderTop: `3px solid ${brandPrimary}`,
		height: '32px',
		width: '32px',
	},
	loadingText: {
		color: gray,
		fontSize: '14px',
		marginTop: '12px',
	},
	errorState: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		minHeight: '200px',
	},
	errorMessage: {
		color: '#d32f2f',
		fontSize: '14px',
		textAlign: 'center',
	},
	emptyState: {
		alignItems: 'center',
		color: gray,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		minHeight: '200px',
	},
	recordingsList: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
	},
	recordingItem: {
		backgroundColor: '#f8f9fa',
		border: `1px solid ${gray}`,
		borderRadius: '8px',
		padding: '16px',
		position: 'relative',
	},
	bestMatch: {
		backgroundColor: '#e8f5e8',
		borderColor: green,
		borderWidth: '2px',
	},
	bestMatchBadge: {
		backgroundColor: green,
		borderRadius: '12px',
		color: white,
		fontSize: '11px',
		fontWeight: 'bold',
		padding: '4px 8px',
		position: 'absolute',
		right: '12px',
		bottom: '12px',
		textTransform: 'uppercase',
	},
	recordingHeader: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: '8px',
	},
	timeInfo: {
		alignItems: 'center',
		display: 'flex',
		gap: '8px',
	},
	date: {
		color: brandPrimary,
		fontFamily: FontFamilies.semiBold,
		fontSize: '16px',
	},
	time: {
		color: brandPrimary,
		fontSize: '16px',
	},
	duration: {
		color: brandPrimary,
		fontSize: '14px',
	},
	actions: {
		alignItems: 'center',
		display: 'flex',
		gap: '12px',
	},
	actionButton: {
		backgroundColor: brandSecondary,
		border: 'none',
		borderRadius: '4px',
		color: white,
		cursor: 'pointer',
		fontSize: '13px',
		fontWeight: 'bold',
		padding: '6px 12px',
		textDecoration: 'none',
		':hover': {
			opacity: 0.9,
		},
	},
	playButton: {
		backgroundColor: brandPrimary,
	},
	transcriptButton: {
		backgroundColor: '#666',
	},
	topic: {
		color: brandPrimary,
		fontSize: '14px',
		fontWeight: 'bold',
		marginBottom: '8px',
	},
	participants: {
		alignItems: 'flex-start',
		display: 'flex',
		gap: '8px',
		maxWidth: '500px',
	},
	participantLabel: {
		color: brandPrimary,
		fontSize: '13px',
		fontWeight: 'bold',
		minWidth: '70px',
	},
	participantNames: {
		color: brandPrimary,
		cursor: 'help',
		fontSize: '13px',
		wordWrap: 'break-word',
	},
});

// Add keyframes for loading spinner
if (typeof document !== 'undefined') {
	const style = document.createElement('style');
	style.textContent = `
		@keyframes spin {
			0% { transform: rotate(0deg); }
			100% { transform: rotate(360deg); }
		}
	`;
	document.head.appendChild(style);
}
